import {
    DELETEENTITYMAPPING_SUCCESS,
    DELETEENTITYMAPPING_FAILED,
    RESET_DELETEENTITYMAPPING,
    LOADING_DELETEENTITYMAPPING,
    NETWORK_ERROR_DELETEENTITYMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetDeleteEntityMappingList = () => {
    return { type: RESET_DELETEENTITYMAPPING };
};

const deleteEntityMappingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETEENTITYMAPPING });
    await adminServices
        .post("deleteEntityMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(deleteEntityMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(deleteEntityMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_DELETEENTITYMAPPING, payload: err });
        });
};
function deleteEntityMappingListsuccess(data) {
    return {
        type: DELETEENTITYMAPPING_SUCCESS,
        payload: data,
    };
}
function deleteEntityMappingListFailed(data) {
    return {
        type: DELETEENTITYMAPPING_FAILED,
        payload: data,
    };
}

export { resetDeleteEntityMappingList, deleteEntityMappingList };
